import { render, staticRenderFns } from "./mobile-nav-foot.vue?vue&type=template&id=de7c3c48&scoped=true"
import script from "./mobile-nav-foot.vue?vue&type=script&lang=js"
export * from "./mobile-nav-foot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7c3c48",
  null
  
)

export default component.exports